import React from 'react';
import PropTypes from 'prop-types';
import { LANGS, missingLangs } from './navEditorState';

// The "Stack" language editor: all four languages of one text on one screen.
// EN is mandatory; empty languages ghost the EN value and copy it in one click.
const NavLangStackEditor = ({
  label, text, onChangeText, url, onChangeUrl, urlPlaceholder, urlLabel,
  visible, onToggleVisible, onDelete, onDone, children,
}) => {
  const value = text || {};
  const missing = missingLangs(value);
  const enEmpty = missing.indexOf('en') !== -1;
  const missingCount = missing.filter(lang => lang !== 'en').length;
  const setLang = (lang, v) => onChangeText({ ...value, [lang]: v });

  return (
    <div className="mnv-editor">
      <div className="mnv-editor-head">
        <span className="mnv-lab">{label}</span>
        <button type="button" className="mnv-iconbtn" title="Close" onClick={onDone}>✕</button>
      </div>
      {LANGS.map((lang) => {
        const empty = !(value[lang] && String(value[lang]).trim());
        const isEn = lang === 'en';
        return (
          <div className="mnv-langrow" key={lang}>
            <span className={`mnv-lang${isEn ? ' mnv-lang--en' : ''}${!isEn && empty ? ' mnv-lang--miss' : ''}`}>
              {isEn ? 'EN*' : lang.toUpperCase()}
            </span>
            <input
              type="text"
              className={`mnv-input${!isEn && empty ? ' mnv-input--miss' : ''}${isEn && enEmpty ? ' mnv-input--err' : ''}`}
              value={value[lang] || ''}
              placeholder={!isEn && value.en ? `EN: "${value.en}"` : ''}
              onChange={e => setLang(lang, e.target.value)}
            />
            {!isEn && empty && Boolean(value.en) && (
              <button type="button" className="mnv-copyen" onClick={() => setLang(lang, value.en)}>copy EN</button>
            )}
          </div>
        );
      })}
      {onChangeUrl && (
        <div className="mnv-langrow">
          <span className="mnv-lang mnv-lang--url">{urlLabel}</span>
          <input
            type="text"
            className="mnv-input mnv-input--mono"
            value={url || ''}
            placeholder={urlPlaceholder}
            onChange={e => onChangeUrl(e.target.value)}
          />
        </div>
      )}
      {enEmpty && <div className="mnv-warn mnv-warn--row mnv-warn--err">EN is required</div>}
      {!enEmpty && missingCount > 0 && (
        <div className="mnv-warn mnv-warn--row">{`${missingCount} language${missingCount > 1 ? 's' : ''} missing — will fall back to EN`}</div>
      )}
      {children}
      <div className="mnv-editor-foot">
        {onToggleVisible && (
          // eslint-disable-next-line jsx-a11y/label-has-for
          <label className="mnv-check">
            <input type="checkbox" checked={visible !== false} onChange={() => onToggleVisible()} />
            visible
          </label>
        )}
        {onDelete && (
          <button
            type="button"
            className="mnv-delete"
            onClick={() => {
              // eslint-disable-next-line no-alert
              if (window.confirm('Delete this entry?')) onDelete();
            }}
          >
            delete
          </button>
        )}
        <button type="button" className="mnv-done" onClick={onDone}>DONE</button>
      </div>
    </div>
  );
};

NavLangStackEditor.propTypes = {
  label: PropTypes.string.isRequired,
  text: PropTypes.shape(),
  onChangeText: PropTypes.func.isRequired,
  url: PropTypes.string,
  onChangeUrl: PropTypes.func,
  urlPlaceholder: PropTypes.string,
  urlLabel: PropTypes.string,
  visible: PropTypes.bool,
  onToggleVisible: PropTypes.func,
  onDelete: PropTypes.func,
  onDone: PropTypes.func.isRequired,
  children: PropTypes.node,
};

NavLangStackEditor.defaultProps = {
  text: null,
  url: '',
  onChangeUrl: null,
  urlPlaceholder: '',
  urlLabel: 'URL',
  visible: true,
  onToggleVisible: null,
  onDelete: null,
  children: null,
};

export default NavLangStackEditor;
